import * as React from 'react';
import InvestorDeckStep1Component from 'src/modules/investor-deck/partials/InvestorDeckStep1.component';
import InvestorDeckStep2Component from 'src/modules/investor-deck/partials/InvestorDeckStep2.component';
import InvestorDeckTabsComponent from 'src/modules/investor-deck/partials/InvestorDeckTabs.component';
import './../ShowInvestorDeck.css';

export interface InvestorDeckComponentProps {
  checks: {[key: string]: boolean};
  disableButton: boolean;
  allowButton: boolean;
  investorDeckDocument?: File;
  investorDeckDocumentName?: string;
  investorDeckSection: string;
  errorMessages: {};
  handleClick: (value: string) => void;
  handleChange: (key: string) => (value: boolean | File) => void;
  createInvestorDeck: () => void;
}

class InvestorDeckStepsComponent extends React.PureComponent<InvestorDeckComponentProps> {

  public render(): React.ReactNode {
    return (
      <section className="investor-deck-steps">
        <div className="container">
          <div className="gap-50"/>
          <div className="row">
            <InvestorDeckTabsComponent
              investorDeckSection={this.props.investorDeckSection}
              handleClick={this.props.handleClick}
            />
            <div className="row">
              <div className="col-sm-12 padding-l-r-0">
                <div className="tab-shadow-control">
                  {this.renderForm(this.props.investorDeckSection)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  private renderForm(section: string): React.ReactNode {
    switch (section) {
      case 'companyInformation':
        return (
          <InvestorDeckStep1Component
            checks={this.props.checks}
            allowButton={this.props.allowButton}
            handleChange={this.props.handleChange}
            handleClick={this.props.handleClick}
          />
        );
      case 'investorDeck':
        return (
          <InvestorDeckStep2Component
            disableButton={this.props.disableButton}
            investorDeckDocument={this.props.investorDeckDocument}
            investorDeckDocumentName={this.props.investorDeckDocumentName}
            errorMessages={this.props.errorMessages}
            handleClick={this.props.handleClick}
            createInvestorDeck={this.props.createInvestorDeck}
            handleChange={this.props.handleChange}
          />
        );
      default:
        return null;
    }
  }

}

export default InvestorDeckStepsComponent;



// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/InvestorDeckSteps.component.tsx